import {
	ContentV2,
	ContentType,
	PartialContents,
	CreateDiscussionPayloadV2,
	ReplyDiscussionPayloadV2,
} from '@front-app/services/GroupsApi/DiscussionModel';
import { UrlInfo } from '@front-app/services/UrlApi/UrlInfoModel';
import { isAxiosError } from '@front-app/util/axios';
import { MessageState } from './Model';

export const getContentDomId = (itemId: string): string => `content_${itemId}`;

export const linksToContent = (links: UrlInfo[]): PartialContents => links.map((link) => ({
	type: ContentType.LINK,
	name: link.pageTitle,
	description: link.pageDescription,
	// The URL to the content
	source: link.requestedUrl,
}));

export const getCreateDiscussionPayload = (
	messageState: MessageState,
): CreateDiscussionPayloadV2 => {
	const attachments = linksToContent(Object.values(messageState.links));
	return {
		subject: messageState.subjectText,
		messageText: messageState.messageText,
		following: messageState.following,
		notifyMembers: messageState.notifyMembers,
		categories: messageState.categories,
		attachments,
	};
};

export const getReplyDiscussionPayload = (
	messageState: MessageState,
	original: Pick<ContentV2, 'name' | 'categories'>,
	following: boolean,
): ReplyDiscussionPayloadV2 => {
	const attachments = linksToContent(Object.values(messageState.links));
	return {
		attachments,
		following,
		messageText: messageState.messageText,
		notifyMembers: messageState.notifyMembers,
		subject: original.name,
		categories: original.categories,
		version: 0,
	};
};

export function isNeedRefreshError(e: unknown): boolean {
	return isAxiosError(e)
		&& e.response?.status === 400
		&& e.response.data === 'Another user added a message first. Please review.';
}
